// extras.js for additional small things
import $ from 'jquery'

function injectYoutubeVideo(obj, vidlnk) { // console.log(vidlnk);
  let vidcaption = ''
  const vidcaptionobj = obj.find('figcaption')
  if (vidcaptionobj.length) {
    vidcaption = vidcaptionobj.html()
  }
  let vidhtml = '<div class="asset zips image asset--video" data-pattern="assets" data-patterntype="video">'
  vidhtml += '<iframe style="width:500px !important; height:281px !important" src="' + vidlnk + '" frameborder="0" scrolling="no"></iframe>'
  vidhtml += (vidcaption !== '') ? '<div><b class="asset__caption image__caption">' + vidcaption + '</b></div></div>' : ''
  obj.after(vidhtml)
  obj.hide()
}

// ch
chExtras()
// ct
ctExtras()

function chExtras() {
  if ($('#z1511211215652945').length) {
    $('#z1511211215652945 figure a').removeClass('js-pswp-image')
    $('#z1511211215652945 figure a').attr('href', 'https://maker-faire.de/makerspaces/')
  }
  // ch 01/2018, s48
  if ($('#z1519686515891258 #asset_4').length) {
    const obj = $('#z1519686515891258 #asset_4')
    const vidlnk = 'https://www.youtube.com/embed/q4UCn_0C8iY'
    injectYoutubeVideo(obj, vidlnk)
  }
}

function ctExtras() {
  let obj, vidlnk
  /* ct 26/2017 youtube links, s. 112, 181 */
  if ($('#z1513892909161543 #asset_3').length) {
    obj = $('#z1513892909161543 #asset_3')
    vidlnk = 'https://www.youtube.com/embed/Ly8He-5cc_Q'
    injectYoutubeVideo(obj, vidlnk)
  }
  if ($('#z1513539893959572 #asset_2').length) {
    obj = $('#z1513539893959572 #asset_2')
    vidlnk = 'https://www.youtube.com/embed/a3SZ63-OTic'
    injectYoutubeVideo(obj, vidlnk)
  }
  /* ct 02/2018, s 180 */
  if ($('#z1515288489453026 #asset_2').length) {
    obj = $('#z1515288489453026 #asset_2')
    vidlnk = 'https://www.youtube.com/embed/owUZUdyRVcQ'
    injectYoutubeVideo(obj, vidlnk)
  }
  /* ct 11/2018, S.76 */
  if ($('#z1526856575537431 #asset_2').length) {
    obj = $('#z1526856575537431 #asset_2')
    vidlnk = 'https://www.youtube.com/embed/6LhoIhoALWQ'
    injectYoutubeVideo(obj, vidlnk)
  }
}
